import { createScanEventQueue } from '../utils/scanEventQueue.util';

/** Process-wide FIFO for raw scan events; single-consumer. */
export const SCAN_EVENT_QUEUE = createScanEventQueue();
